/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fileName: NonNullable<unknown> }} Coinvestments_Dataroom_Retryuploaditem4Inputs */

const en_coinvestments_dataroom_retryuploaditem4 = /** @type {(inputs: Coinvestments_Dataroom_Retryuploaditem4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retry uploading ${i?.fileName}`)
};

/**
* | output |
* | --- |
* | "Retry uploading {fileName}" |
*
* @param {Coinvestments_Dataroom_Retryuploaditem4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_retryuploaditem4 = /** @type {((inputs: Coinvestments_Dataroom_Retryuploaditem4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Retryuploaditem4Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_retryuploaditem4(inputs)
});
export { coinvestments_dataroom_retryuploaditem4 as "coInvestments_dataRoom_retryUploadItem" }